import { basicEnum } from "./base";

export const WhatsAppStatusEnum = basicEnum([
    {
        label: "ACCEPTED",
        value: "accepted",
    },
    {
        label: "SENT",
        value: "sent",
    },
    {
        label: "DELIVERED",
        value: "delivered",
    },
    {
        label: "FAILED",
        value: "failed",
    },
]);

export namespace WhatsAppStatusEnum {
    export type Labels = (typeof WhatsAppStatusEnum)["labels"][number];
    export type Values = (typeof WhatsAppStatusEnum)["values"][number];
}
